import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { AlipayPortalPage } from "./alipay-portal";

@NgModule({
  declarations: [AlipayPortalPage],
  imports: [IonicPageModule.forChild(AlipayPortalPage)],
})
export class AlipayPortalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/alipay-portal/alipay-portal.module.ts